export default {
  saveToken(state, accessToken) {
    state.token = accessToken;
  },
  logout(state) {
    state.token = null;
  },
};
